import React, { useMemo } from 'react'
import { StyledWorkRangeBar, StyledWorkRangeBox } from '../../../styles/LeaderCalendarTableStyles'
import { WeeklyCalendarTooltip } from './WeeklyCalendarTooltip'
import { calculateMenteeBar } from '../../../store/utils/calculateMenteeBar'
import { Mentee } from '../../../store/types/response/LeaderMenteesPlanResponse'

type WeeklyBarProps = {
  day: string
  hour: string
  mentee: Mentee
}

export const WeeklyBar = ({ day, hour, mentee }: WeeklyBarProps) => {
  const workDay = useMemo(() => mentee.workSchedule.find(s => s.date === day), [mentee.workSchedule, day])

  const foundShift = useMemo(
    () => workDay?.shifts?.find(shift => shift.from.startsWith(hour.slice(0, 2))),
    [workDay, hour]
  )

  const isStartWorkingTimeRange = Boolean(foundShift && !workDay?.isVacation)
  const isStartVacationTimeRange = Boolean(workDay?.isVacation && hour === '00:00')

  if (!isStartWorkingTimeRange && !isStartVacationTimeRange) return <StyledWorkRangeBox />

  const startHour = foundShift?.from.slice(0, 5) || '0:00'
  const endHour = foundShift?.to.slice(0, 5) || '24:00'

  const { height, padding } = calculateMenteeBar(hour, startHour, endHour, isStartVacationTimeRange)

  return (
    <WeeklyCalendarTooltip
      mentee={`${mentee.firstName} ${mentee.lastName}`}
      day={day}
      hour={`${startHour} - ${endHour}`}
      isWorkingRangeTooltip={isStartWorkingTimeRange}
    >
      <StyledWorkRangeBox paddingTop={padding}>
        <StyledWorkRangeBar isWorkingTimeBar={isStartWorkingTimeRange} height={height}></StyledWorkRangeBar>
      </StyledWorkRangeBox>
    </WeeklyCalendarTooltip>
  )
}
